import { OneColumn } from 'components/page';
import { SellersVtexFilter } from 'pages/logistica/sellers-vetex/components/SellersVtexFilter';
import { SellersVtexGrid } from 'pages/logistica/sellers-vetex/components/SellersVtexGrid';
import { SellersVtexReport } from 'pages/logistica/sellers-vetex/components/SellersVtexReport';

export function SellersVtexListComp() {
    return (
        <OneColumn title="Sellers VTEX" goBackButton>
            <SellersVtexFilter />

            <SellersVtexReport />

            <SellersVtexGrid />
        </OneColumn>
    );
}
